

const state = {
    cadrelist: null,
    itemTree: null,
    dictionary:null,
    itemColumns:null,
}

const mutations = {
    SET_CADRES: (state, cadres) => {
        state.cadrelist = cadres;
    },
    SET_ITEMTREE: (state, itemTree) => {
        state.itemTree = itemTree;
    },
    SET_DICTIONARY: (state, dictionary) => {
        state.dictionary = dictionary;
    },
    SET_ITEMCOLUMNS: (state, itemColumns) => {
        state.itemColumns = itemColumns;
    },
}

const actions = {
    reset_cadres({ commit }) {
        return new Promise(resolve => {
            commit('SET_CADRES', null)
        })
    },
    reset_item_tree({ commit }) {
        return new Promise(resolve => {
            commit('SET_ITEMTREE', null)
        })
    },
    reset_dictionary({ commit }) {
        return new Promise(resolve => {
            commit('SET_DICTIONARY', null)
        })
    },
    reset_itemColumns({ commit }) {
        return new Promise(resolve => {
            commit('SET_ITEMCOLUMNS', null)
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}